import { render } from "./modal-event.vue?vue&type=template&id=542fa682"
import script from "./modal-event.vue?vue&type=script&lang=js"
export * from "./modal-event.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__